import React from 'react';
import PropTypes from 'prop-types';

import { useSSRQuery } from '../';

export const ApplicationQueryContext = React.createContext({});
export const useTranslations = () =>
  React.useContext(ApplicationQueryContext).translations;
export const useConfigurations = () =>
  React.useContext(ApplicationQueryContext).configurations;

const applicationQueryProviderPropTypes = {
  query: PropTypes.object,
  children: PropTypes.node,
};

const ApplicationQueryProvider = ({ query, children }) => {
  const { loading, error, data } = useSSRQuery(query);

  if (loading) {
    return null;
  }

  if (error) {
    throw error;
  }

  if (data && !data.application && !data.allegiantApplication) {
    throw new Error(
      `You need to supply an application query to "withApplicationQuery" or to "ApplicationQueryProvider". The provided query is not an application query: ${query.loc.source.body}`
    );
  }

  const applicationData = data?.application
    ? data.application
    : data?.allegiantApplication;

  return (
    <ApplicationQueryContext.Provider value={applicationData}>
      {children}
    </ApplicationQueryContext.Provider>
  );
};

ApplicationQueryProvider.propTypes = applicationQueryProviderPropTypes;

export function withApplicationQuery(query, WrappedComponent) {
  return function ApplicationQueryHOC(props) {
    return (
      <ApplicationQueryProvider query={query}>
        <WrappedComponent {...props} />
      </ApplicationQueryProvider>
    );
  };
}

export default ApplicationQueryProvider;
